/* eslint-disable import/no-cycle */
import React from 'react';
import { navigate } from 'gatsby';
import useQueryData from './use-query-data';
const getLink = (props) => {
    if (props?.to && typeof props.to === "string") {
        return {
            link: props.to,
            children: ""
        };
    }
    if (props?.[0] && props?.[0]?.link) {
        let externalLink = props?.[0]?.link?.[0]?.externalLink;
        let internalLink = props?.[0]?.link?.[0]?.internalLink?.permalink;
        return {
            link: externalLink || internalLink,
            children: props?.[0]?.title || ""
        };
    }
    return {
        link: "",
        children: "Invalid Link",
        isInvalid: true,
    };
};
const Link = ({ to, children, onClick, lang, goToRootIfNoMatch, ...props }) => {
    const { link: trueTo, children: altChildren, isInvalid, } = getLink({ to, ...props });
    const [path, queryString, hash] = useQueryData(trueTo);
    const linkRef = React.useRef(null);
    const linkIsExternal = path.includes(':') || path.startsWith('www.');
    if (linkIsExternal) {
        return (React.createElement("a", { ref: linkRef, href: trueTo, rel: "noreferrer noopener", ...props }, children || altChildren));
    }
    const relative = `${path.startsWith("/") ? path : `/${path}`}${path.endsWith("/") ? "" : "/"}${queryString}`;
    // the below is correct - some serialization of string issue with webpack, needs to be 'undefined'
    const formatted = `${(process.env.GATSBY_URL === "undefined" || !process.env.GATSBY_URL) ? 'https://localhost:8000' : process.env.GATSBY_URL}${relative}`;
    return (React.createElement("a", { 
        // eslint-disable-next-line
        // @ts-ignore
        ref: linkRef, href: formatted, onClick: (e) => {
            e.preventDefault();
            if (hash) {
                // eslint-disable-next-line
                // @ts-ignore
                window.gatsby_router_hash = hash;
            }
            if (onClick) {
                onClick(e);
            }
            navigate(relative);
        }, ...props }, children || altChildren));
};
export default Link;
//# sourceMappingURL=index.js.map